export default __webpack_public_path__ + "static/pancakes-ee3fce7669c0311c9af5c1418534a966.jpg";